import { StoriesViewLiked } from '../../assets/images';
import { formatUserIdToJid, getUserDetails } from '../../Helpers/Chat/User';
import ImageComponent from '../WebChat/Common/ImageComponent';

const ViewerList = ({ viewersList = [] }) =>
    viewersList.map((viewer, index) => {
        const details = getUserDetails(formatUserIdToJid(viewer.viewerUsername));

        const displayName = details?.displayName || details?.initialName || details?.name || viewer.viewerUsername;

        return (
            <div className="viewer-item" key={index}>
                <div className="viewer-avatar">
                    <ImageComponent
                        chatType="chat"
                        userToken={details?.userToken}
                        imageToken={details?.thumbImage || details?.image}
                        name={displayName}
                    />
                </div>
                <div className="viewer-info">
                    <span className="viewer-name">{displayName}</span>
                    {/* <span className="viewer-time">{formatViewedAt(viewer.viewedAt)}</span> */}

                    {Boolean(viewer?.like) && (
                        <i>
                            <StoriesViewLiked />
                        </i>
                    )}
                </div>
            </div>
        );
    });

export default ViewerList;
